import { useEffect } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';
import { APP_ROUTES } from 'routes/Routes';

import state from 'components/state';

const APP_SUFFIX = 'Myriad Health';

const useAutoDocumentTitle = () => {
  const location = useLocation();
  const titleOverride = useRecoilValue(state.documentTitleOverride);

  useEffect(() => {
    if (titleOverride) {
      document.title = `${titleOverride} | ${APP_SUFFIX}`;
      return;
    }

    const matches = matchRoutes(APP_ROUTES, location);
    const titles = matches?.map((m) => m.route.handle?.title).filter(Boolean) || [];

    document.title = titles.length ? `${titles.join(' - ')} | ${APP_SUFFIX}` : APP_SUFFIX;
  }, [location.pathname, titleOverride]);
};

export default useAutoDocumentTitle;
